import { render, staticRenderFns } from "./table-campaign-tags.vue?vue&type=template&id=46069856"
import script from "./table-campaign-tags.vue?vue&type=script&lang=js"
export * from "./table-campaign-tags.vue?vue&type=script&lang=js"
import style0 from "./table-campaign-tags.vue?vue&type=style&index=0&id=46069856&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports